import { ActionReducerMap, createFeatureSelector, combineReducers } from '@ngrx/store';
import * as fromRepeatOrder from '@ordersnproducts/modules/new-repeat-order/reducers/base.reducer';
import * as fromOrderSelectedDetail from '@ordersnproducts/modules/new-repeat-order/reducers/order-detail.reducer';
import * as fromOrderState from '@ordersnproducts/modules/new-repeat-order/reducers/order.reducer';
import * as fromTopLocationState from '@ordersnproducts/modules/new-repeat-order/modules/rms-top-location/reducers';
import { InjectionToken } from '@angular/core';
import { State } from '@cemex/cmx-client-layout';

export const repeatOrderKey = 'NewRepeatOrder';

export interface RepeatFeatureState {
  repeatOrder: fromRepeatOrder.RepeatOrderState;
  orderSelectedDetail: fromOrderSelectedDetail.OrderSelectedDetailState;
  order: fromOrderState.OrderState;
  topLocation: fromTopLocationState.TopLocationState;
}

export interface RepeatOrderState extends State {
  RepeatOrderState: RepeatFeatureState;
}

export const reducers = {
  repeatOrder: fromRepeatOrder.reducer,
  orderSelectedDetail: fromOrderSelectedDetail.reducer,
  order: fromOrderState.orderReducer,
  topLocation: fromTopLocationState.reducers,
};

export const combinedReducers = combineReducers({
  ...reducers,
});

export const reducerToken = new InjectionToken<ActionReducerMap<RepeatOrderState>>('COMBINED_REDUCERS');

export function getReducers() {
  return combinedReducers;
}

export const ReducerProvider = { provide: reducerToken, useFactory: getReducers };

export const getNewRepeatOrderState = createFeatureSelector<RepeatFeatureState>(repeatOrderKey);
